export const locale = {
    lang: 'ds',
    data: {
        'TITLE': {
            'HeaderForLeaveNotification': 'Ansøg om frihed',
            'HeaderForRemoveNotification': 'Notifikation på  planlægning fjernes',
            'HeaderForInquiryNotification': 'Notifikation på forespørgsler',
            'HeaderForOfferNotification': 'Notifikation på tilbud er godkendt',
            'HeaderForOfferRejectedNotification': 'Notifikation på tilbud er afvist',
            'HeaderForProjectStatusBeforeSevenDaysNotification': 'Notifikation på projektstatus (inden for 7 dage)',
            'HeaderForProjectWarningMaterialColorcodeNotification': 'Notifikation på projekt forskellige Materiale farvekode',
            'HeaderForProjectQualityTestNotification': 'Notifikation på projekt kvalitetstest',
            'HeaderForCustomerOverdueNotification': 'Meddelelse om forfalden kunde',
            'HeaderForReviewReminder': 'Gennemgå påmindelser',
            'StatusSms': 'Status Sms',
            'HeaderForOfferReviewReminder': 'påmindelse om gennemgang af tilbud'
        },
        'FIELDS': {
            'DaysToSend': 'Send x dage før',
            'SMSText': 'SMS tekst',
            'NotificationText': 'Notifikations tekst',
            'EmailText': 'E-mail tekst',
            'ExecuteTime': 'Udfør tid',
            'IsCreateReminder': 'Opret påmindelse?',
            'NotesLabel': "Slet ikke et præfiks '@'-tegnord.",
            'ProjectWarningMaterialColorCodeReminderExtraTextLabel': "Farvekode",
            'Status': 'Status',
            'Dates': 'Dag',
            'PleaseDoNotDeleteLabel': 'Fjern venligst ikke virksomhedsoplysninger såsom @LogoImage, @Name, @Address, @Postcode, @City, @Phone, @Email, @WWW og @FullAddressDetail',
            'PleaseDoNoDeleteLabelForStatusSms': 'Fjern venligst ikke @ProjectNumer, @ProjectAddress, @ProjectStatus'

        },
        'VALIDATIONS': {
            'DaysToSend': 'dage at sende er påkrævet',
            'SMSText': 'SMS-tekst er påkrævet',
            'NotificationText': 'Notifikations tekst er påkrævet',
            'EmailText': 'E-mail-tekst er påkrævet',
        },
        'MESSAGES': {
            'Saved': 'Gemt succesfuldt.',
        },
        'Label': {
            'InquirySMSLabel': 'Fjern venligst ikke @CustomerName ,@InquiryDate, @InquiryNumber og @Address fra SMS tekst.',
            'PlanningLeaveSMSLabel': 'Fjern venligst ikke @CoworkerName og @LeaveDate fra SMS tekst.',
            'OfferSMSLabel': 'Fjern venligst ikke @CustomerName, @OfferNumber, @OfferAddress og @OfferTotal fra SMS tekst.',
            'OfferRejectedSMSLabel': 'Fjern venligst ikke @CustomerName, @OfferNumber, @OfferAddress og @OfferTotal fra SMS tekst.',
            'ProjectStatusBeforeSevenDaysSMSLabel': 'Fjern venligst ikke @Count fra SMS tekst.',
            'ProjectWarningMaterialColorcodeSMSLabel': 'Fjern venligst ikke @ProjectNumber og @ProjectAddress SMS tekst.',
            'InquiryNotificationLabel': 'Fjern venligst ikke @CustomerName ,@InquiryDate, @InquiryNumber og @Address fra notifikations tekst.',
            'PlanningLeaveNotificationLabel': 'Fjern venligst ikke @CoworkerName og @LeaveDate fra notifikations tekst.',
            'OfferNotificationLabel': 'Fjern venligst ikke @CustomerName, @OfferNumber, @OfferAddress og @OfferTotal fra notifikations tekst.',
            'OfferRejectedNotificationLabel': 'Fjern venligst ikke @CustomerName, @OfferNumber, @OfferAddress og @OfferTotal fra notifikations tekst.',
            'ProjectStatusBeforeSevenDaysNotificationLabel': 'Fjern venligst ikke @Count fra notifikations tekst.',
            'ProjectWarningMaterialColorcodeNotificationLabel': 'Fjern venligst ikke @ProjectNumber og @ProjectAddress fra notifikations tekst.',
            'ProjectWarningMaterialColorCodeReminder': 'Du vil tilføje flere farvekode sammenføjninger med komma "," For eksempel S-005,N-008,005',
        },
        'WeekDayExecute': {
            "isExecuteMonday": "Monday",
            "isExecuteMondayTime": "Monday Execute Time",
            "isExecuteTuesday": "Tuesday",
            "isExecuteTuesdayTime": "Tuesday Execute Time",
            "isExecuteWednesday": "Wednesday",
            "isExecuteWednesdayTime": "Wednesday Execute Time",
            "isExeciteThursday": "Thursday",
            "isExeciteThursdayTime": "Thursday Execute Time",
            "isExeciteFriday": "Friday",
            "isExeciteFridayTime": "Friday Execute Time",
            "isExeciteSaturday": "Saturday",
            "isExeciteSaturdayTime": "Saturday Execute Time",
            "isExecuteSunday": "Sunday",
            "isExecuteSundayTime": "Sunday Execute Time",
        },
        'BUTTONS': {
            'Save': 'Gem',
        }
    }
};
